/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramTransactionsUserControllerFindAllQueryResponse,
  TelegramTransactionsUserControllerFindAllQueryParams,
  TelegramTransactionsUserControllerFindAll401,
} from '../../types/TelegramTransactionsUserControllerFindAll.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramTransactionsUserFindAll } from '../../methods/telegramTransactionsUserFindAll.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramTransactionsUserFindAllQueryKey = (
  params?: TelegramTransactionsUserControllerFindAllQueryParams,
) => [{ url: '/api/user/telegram/transactions' }, ...(params ? [params] : [])] as const;

export type TelegramTransactionsUserFindAllQueryKey = ReturnType<typeof telegramTransactionsUserFindAllQueryKey>;

export function telegramTransactionsUserFindAllQueryOptions(
  params?: TelegramTransactionsUserControllerFindAllQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramTransactionsUserFindAllQueryKey(params);
  return queryOptions<
    TelegramTransactionsUserControllerFindAllQueryResponse,
    ResponseErrorConfig<TelegramTransactionsUserControllerFindAll401>,
    TelegramTransactionsUserControllerFindAllQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramTransactionsUserFindAll(params, config);
    },
  });
}

/**
 * {@link /api/user/telegram/transactions}
 */
export function useTelegramTransactionsUserFindAll<
  TData = TelegramTransactionsUserControllerFindAllQueryResponse,
  TQueryData = TelegramTransactionsUserControllerFindAllQueryResponse,
  TQueryKey extends QueryKey = TelegramTransactionsUserFindAllQueryKey,
>(
  params?: TelegramTransactionsUserControllerFindAllQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramTransactionsUserControllerFindAllQueryResponse,
        ResponseErrorConfig<TelegramTransactionsUserControllerFindAll401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramTransactionsUserFindAllQueryKey(params);

  const query = useQuery(
    {
      ...telegramTransactionsUserFindAllQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<TelegramTransactionsUserControllerFindAll401>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
